import React, {useState} from "react";
import SideNav from "../components/SideNav";
import { ListContext } from "../components/ListContext";

export const LayoutDashboard = () => {

  const [listData, setListData] = useState({})

  return (
    <div>
      <ListContext.Provider value={{listData,setListData}}>
        <SideNav />
      </ListContext.Provider>
    </div>
  );
};